// 主播管理
import {
  basePost,
  myBasePost
} from '../utils/request';

// 主播列表
export function getAnchorList(data) {
  return basePost('/news/getAnchorList', data)
}
// 获取详情
export function getAnchorDetail(data) {
  return basePost('/news/getAnchorDetail', data)
}

// 新闻banner
export function getNewsBanner(data) {
  return myBasePost("/news/getBannerList", data);
}

// 新闻类型
export function getNewsType(data) {
  return myBasePost("/news/getNewsCategory", data);
}

// 新闻列表
export function getNewsList(data) {
  return myBasePost("/news/getNewsLists", data);
}

// 新闻详情
export function getNewsDetail(data) {
  return myBasePost("/news/getNews_detail", data);
}

// 主播列表
export function getIdentifyAnchorList(data) {
  return myBasePost("/news/getAnchorInfo", data);
}

// 客服列表
export function getIdentifyCustomerList(data) {
  return myBasePost("/news/getCustomerInfo", data);
}